import React, { Component } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Growl } from "primereact/growl";
import NetiContentLoader from '../../common/NetiContentLoader';
import { ErrorMessageView } from '../../common/ErrorMessageView';
import { ChatBoxService } from '../../../service/chatBox/chatBoxService';
import Formatter from '../../../utils/Formatter';
import CommonFuctionality from '../../common/CommonFuctionality';
import { CRMPointService } from '../../../service/crmPoint/CRMPointService';
import { ProfileService } from '../../../service/profile/ProfileService';
import { SendSmsAndNetiMail } from "../../common/SendSmsAndNetiMail";
import {Dropdown} from 'primereact/dropdown';



export class MessageSendToPointTypeWise extends Component {
    constructor(props) {
        super(props);
        this.state = {
            messageBody: "",
            userInfo: {},
            errors: {},
            dataTableIsLoading: false,
            topProgressBar: false,
            searchIsLoading: false,
            dataTableValue: [],
            searchViewError: false,
            searchIsLoadingFirst: false,
            searchIsLoadingSecond: false,
            uploadImage: {},
            secondSearchIsLoading: false,
            secondSearchErrorMsg: '',
            secondfirstSearchView: false,
            secondSearchErrorVisible: false,
            netiInformation:{},
            disableAddButton: true,
            /***Data table checkbox***/
            pointType:[],
            selectPointCat:null,
            selectPointType:null,
            selectedCustomers: [],
            globalFilter: null,
            selectedRepresentatives: null,
            
        };
        
        this.NetiContentLoader = new NetiContentLoader();
        this.formatter = new Formatter();
        this.CommonFuctionality = new CommonFuctionality();
        this.CRMPointService = new CRMPointService();

    }


    componentWillMount(){
        this.getPointTypekHandler();
    }

    getPointTypekHandler = () =>{
        let { pointType, topProgressBar, firstDropdownIsLoading} = this.state; 
        this.setState({ topProgressBar: true, firstDropdownIsLoading: true, errorMsgVisible: false });
       
        this.CRMPointService.getPointTypeList()
            .then(res => {
                if (res.status == 302) {
                    this.setState({ topProgressBar: false, firstDropdownIsLoading: false });
                    return res.json().then((body) => {
                        for (let index = 0; index < body.length; index++) {
                            let parent = { 
                                "label" : body[index].coreRoleNote,
                                "value" : body[index].coreRoleName
                            }
                            pointType.push(parent);
                        }
                        
                    });
                    
                }
        }).catch(error => {
            this.setState({ topProgressBar: false, firstDropdownIsLoading: false, errorMsgVisible: true, errorMsgBody: "Please check your connection !!!" });
        });;
    }

    selectPointCategory = (e) =>{
        console.log(e.target.value);
        
        this.setState({selectPointCat : e.target.value});
    }

    selectPointType = (e) => {
        console.log(e.target.value);

        this.setState({selectPointType:e.target.value});
    }

    netiSmsHandleError = () => {
        let errors = {};
        let formIsValid = true;
        if (!this.state.selectPointCat) {
            formIsValid = false;
            errors["pointCat"] = "Please Select Point Category.";
        }
        if (!this.state.selectPointType) {
            formIsValid = false;
            errors["pointType"] = "Please Select Point Type.";
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    
    addSenderInformation = () => {
        if(this.netiSmsHandleError()){
            let { topProgressBar, firstDropdownIsLoading, selectPointCat, selectPointType } = this.state; 
            this.setState({ topProgressBar: true, dataTableIsLoading: true, errorMsgVisible: false });
            this.CRMPointService.getUserDetailsPointWise(selectPointCat, selectPointType)
                .then(res => {
                    if (res.status == 302) {
                        this.setState({ topProgressBar: false, dataTableIsLoading: false });
                        return res.json().then((body) => {
                           this.setState({dataTableValue : body});
                        });
                        
                    }
            }).catch(error => {
                this.setState({ topProgressBar: false, dataTableIsLoading: false, errorMsgVisible: true, errorMsgBody: "Please check your connection !!!" });
            });;
            
        }
    }
    

    render() {
        let { selectedCustomers, pointType, dataTableValue, topProgressBar, errorMsgVisible, errorMsgBody } = this.state;

        let pointCategory = [
            {label: 'Owner', value: 'em-admin'},
            {label: 'Parent', value: 'em-parent'}
        ];

        let header =  <div className="p-clearfix" style={{ 'lineHeight': '1.87em' }}> Institute List <span style={{ 'float': 'right' }}> Total Found: {dataTableValue.length} </span></div>;
        
        console.log('selectedCustomers - ',this.state.selectedCustomers);
        

        return (
            <div className="p-fluid">
                {topProgressBar ?
                    <ErrorMessageView
                        topProgressBar={topProgressBar}
                    />
                    : null
                }
                {errorMsgVisible ?
                    <ErrorMessageView
                        errorMsgVisible={errorMsgVisible}
                        errorMsgBody={errorMsgBody}
                    />
                    : null
                }
                <Growl ref={el => (this.growl = el)} />
                <div className="main-section">

                    <div className="p-grid nw-form">
                        <div className="p-col-12 p-xl-8 p-col-nogutter seprator">
                            <div className="p-grid seprator-inside">
                                <div className="p-col-12 p-xl-12">
                                    <div className="nw-form-body">
                                    {this.state.firstDropdownIsLoading ?
                                         this.NetiContentLoader.normalFormInputField() :
                                        <div className="p-col-12 p-xl-12">
                                            <div className="p-inputgroup">
                                                <span className="p-inputgroup-addon">Point Category <span>*</span></span>
                                                <Dropdown 
                                                    options={pointCategory} 
                                                    autoWidth={false} 
                                                    placeholder="Select a Category"
                                                    onChange={this.selectPointCategory}
                                                    value={this.state.selectPointCat}
                                                />
                                            </div>

                                            <span className="error-message">{this.state.errors["pointCat"]}</span>
                                        </div>
                                    }
                                    {this.state.firstDropdownIsLoading ?
                                         this.NetiContentLoader.normalFormInputField() :
                                        <div className="p-col-12 p-xl-12">
                                            <div className="p-inputgroup">
                                                <span className="p-inputgroup-addon">Point type <span>*</span></span>
                                                <Dropdown 
                                                    options={pointType} 
                                                    autoWidth={false} 
                                                    placeholder="Select a Point Type"
                                                    onChange={this.selectPointType}
                                                    value={this.state.selectPointType}
                                                />
                                            </div>

                                            <span className="error-message">{this.state.errors["pointType"]}</span>
                                        </div>
                                    }

                                        <div className="p-col-12 p-lg-12 p-xl-12 nw-button-parent">
                                            <Button
                                                className="p-button p-button-primary nw-button nw-button-right"
                                                label="Search"
                                                onClick={this.addSenderInformation}
                                                icon="fas fa-search"
                                            />
                                        </div>
                                        <div className="p-col-12 p-lg-12 p-xl-12 p-col-nogutter">
                                            {
                                                this.state.dataTableIsLoading ? this.NetiContentLoader.MyPointTableLoader():
                                                    <div className="nw-data-table">
                                                        <DataTable
                                                            value={dataTableValue}
                                                            header={header}
                                                            responsive={true}
                                                            selection={this.state.selectedCustomers} 
                                                            onSelectionChange={e => this.setState({selectedCustomers: e.value})}
                                                            paginator={true}
                                                            rows={10}
                                                        >
                                                            <Column selectionMode="multiple" style={{width:'3em'}}/>
                                                            <Column field="netiID" header="Neti ID" filter={true} />
                                                            <Column field="name" header="Name" filter={true} />
                                                            <Column field="mobile" header="Mobile No." filter={true} />
                                                            <Column field="email" header="Email" filter={true} />
                                                        </DataTable>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="p-col-12 p-xl-4">
                            <SendSmsAndNetiMail smsActive={ true } netiMailActive={ true } userInfo={ selectedCustomers } filterData= {true} />
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}
